import React, { Component } from 'react';
import { Card, Table, Form, Input, Button } from 'antd';
import { apiUtil as Util } from '../../mock/mockServices';

class Search extends Component {
    state = {
        name: ''
    }
    keyChange = e => {
        this.setState({
            name: e.target.value
        })
    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.onSearch({
            name: this.state.name
        })
    }
    handleAdd = () => {
        window.location.href = `../orgMgr`;
    }
    render() {
        return (
            <Form layout="inline" className="pt10 pb10">
                <Form.Item label="Organization Name">
                    <Input style={{ width: '300px' }} onChange={this.keyChange} value={this.state.name} placeholder="Fuzzy search by name" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" onClick={this.handleSubmit}>Search</Button>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" style={{ marginLeft: 'auto' }} onClick={this.handleAdd}>Add</Button>
                </Form.Item>
            </Form>
        )
    }
}
const SearchForm = Form.create({ name: 'orgSearch' })(Search)

class OrgList extends Component {
    state = {
        tableLoading: false,
        keyWords: '',
        sorter: {},
        pagination: {
            current: 1,
            pageSize: 20,
            showTotal: total => `${total} items `,
            total: 0
        },
        data: []
    }

    reLoad = () => {
        let pager = { ...this.state.pagination }
        pager.current = 1
        this.setState({
            pagination: pager
        }, () => {
            this.fetch();
        })
    }

    onSearch = keyWords => {
        this.setState({
            keyWords: keyWords
        })
        this.reLoad()
    }

    fetch() {
        const { pagination, keyWords } = this.state
        this.setState({
            tableLoading: true
        })
        Util.ajax.get('/admin/filterOrgList', {
            keyWords: keyWords,
            current: pagination.current,
            pageSize: pagination.pageSize
        }).then(res => {
            pagination.total = res.data.total
            this.setState({
                data: res.data.list,
                pagination,
                tableLoading: false
            })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    handleTableChange = (pagination, filters, sorter) => {
        console.log(pagination, sorter);
        
        const pager = { ...this.state.pagination }
        pager.current = pagination.current
        this.setState({
            pagination: pager,
            sorter: {
                orderBy: sorter.field,
                sort:sorter.order === 'ascend' ? 'asc' : 'desc'
            }
        }, () => {
            this.fetch();
        })
    }

    edit = row => {
        window.location.href = `../orgMgr?id=${row.id}`;
    }

    render() {
        if (this.state.loading) {
            return <div>Loading...</div>;
        }
        const columns = [
            {
                title: 'Organization ID',
                dataIndex: 'id',
                width: 80,
            },
            {
                title: 'Organization Name',
                dataIndex: 'name',
                width: 240,
            },
            {
                title: 'Short Name',
                dataIndex: 'sName',
                width: 120,
            },
            {
                title: 'Organization Code',
                dataIndex: 'code',
                width: 180,
            },
            {
                title: 'Organization Type',
                dataIndex: 'type',
                width: 120,
            },
            {
                title: 'Main Business',
                dataIndex: 'mainBusiness',
                width: 180,
            },
            {
                title: 'Industry',
                dataIndex: 'industry',
                width: 100,
            },
            {
                title: 'Country',
                dataIndex: 'country',
                width: 100,
            },
            {
                title: 'Province',
                dataIndex: 'province',
                width: 100,
            },
            {
                title: 'City',
                dataIndex: 'city',
                width: 100,
            },
            {
                title: 'District',
                dataIndex: 'district',
                width: 160,
            },
            {
                title: 'Address',
                dataIndex: 'address',
                width: 160,
            },
            {
                title: 'Contact Person',
                dataIndex: 'contactPerson',
                width: 100,
            },
            {
                title: 'Contact Mobile',
                dataIndex: 'contactMobile',
                width: 120,
            },
            {
                title: 'Contact Phone',
                dataIndex: 'contactPhone',
                width: 160,
            },
            {
                title: 'Contact Email',
                dataIndex: 'contactEmail',
                width: 210,
            },
            {
                title: 'Actions',
                dataIndex: 'status',
                key: 'active',
                align: 'center',
                render: (status, row) => {
                    return <Button type="link" onClick={() => this.edit(row)}>Edit</Button>
                }
            }
        ]

        return (
            <div className="page-content" style={{ width: '100%', overflowX: 'scroll' }}>
                <Card title="Organization - List Management" bordered={false} style={{ width: '100%', overflowX: 'scroll' }}>
                    <SearchForm onSearch={pms => this.onSearch(pms)}></SearchForm>
                    <Table style={{ width: '100%', borderCollapse: 'collapse' }}
                        rowKey={record => record.id}
                        columns={columns}
                        loading={this.state.tableLoading}
                        dataSource={this.state.data}
                        pagination={this.state.pagination}
                        onChange={this.handleTableChange}
                    />
                </Card>
            </div>
        );
    }
}

export default OrgList;
